module.exports = __webpack_public_path__ + "img/42_48.dc616742.png";